<!-- @format -->

<div class="hmf-display-flex hmf-flex-column">
	<div
		class="review-scroll-container hmf-position-relative hmf-display-flex hmf-align-items-center">
		<div
			[ngClass]="showLeftArrow ? 'hmf-display-lg-flex' : 'hmf-display-none'"
			class="position-button left hmf-align-items-center hmf-justify-content-center hmf-display-none">
			<button
				class="scroll-button hmf-round-radius"
				(click)="scrollList('Left')">
				<homefield-icon name="chevron-left"></homefield-icon>
			</button>
		</div>
		<div
			#scrollableList
			class="hmf-position-relative hmf-display-flex scrollable-container"
			[ngClass]="{ 'scrollable-container--not-scrollable': !activeScroll }"
			[attr.id]="selector"
			(scroll)="refreshArrowVisibility()">
			<ng-content select="[carouselContent]"></ng-content>
		</div>
		<div
			[ngClass]="showRightArrow ? 'hmf-display-lg-flex' : 'hmf-display-none'"
			class="position-button right hmf-align-items-center hmf-justify-content-center hmf-display-none">
			<button
				class="scroll-button hmf-round-radius"
				(click)="scrollList('Right')">
				<homefield-icon name="chevron-right"></homefield-icon>
			</button>
		</div>
	</div>
</div>
